// src/pages/Solutions.js
import Header from '../components/Header';
import Footer from '../components/Footer';
import ImpactCasesSection from '../components/ImpactCasesSection';
import ImpactSummarySection from '../components/ImpactSummarySection';
import BookDemoSection from '../components/BookDemoSection';

const SuccessStories = () => {
  return (
    <div>
      <Header />
      <ImpactCasesSection />
      <ImpactSummarySection />
      <BookDemoSection />
      <Footer/>
    </div>
  );
};

export default SuccessStories;
